var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full md:pl-10 md:w-3/4 md:pr-10" },
    [
      _vm._l(_vm.categoryGroups, function (group) {
        return _vm.categorySlugsByGroupId[group.id] &&
          group.ui_status === "details"
          ? _c("div", { key: group.id, staticClass: "mb-8" }, [
              _c("label", { ref: "categories", refInFor: true }, [
                _vm._v("\n      Event " + _vm._s(group.title) + " "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                _vm._v(" "),
                group.max_categories_allowed < 100
                  ? _c(
                      "span",
                      { staticClass: "block text-sm font-sans-book" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(group.help_text) +
                            " You may choose up to " +
                            _vm._s(group.max_categories_allowed) +
                            ".\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group__checkbox" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap select-box" },
                  [
                    _vm._l(
                      _vm.categorySlugsByGroupId[group.id],
                      function (categorySlug) {
                        return [
                          _c(
                            "label",
                            {
                              key: categorySlug,
                              staticClass:
                                "w-full text-base font-normal md:w-1/2 md:pr-3",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.form.categoriesForGroup[group.id],
                                    expression:
                                      "form.categoriesForGroup[group.id]",
                                  },
                                ],
                                attrs: {
                                  disabled:
                                    _vm.categoryGroupDisabled(group.id) &&
                                    !_vm.form.categoriesForGroup[
                                      group.id
                                    ].includes(categorySlug),
                                  name: `event ${group.title}`.toLowerCase(),
                                  type: "checkbox",
                                },
                                domProps: {
                                  value: categorySlug,
                                  checked: Array.isArray(
                                    _vm.form.categoriesForGroup[group.id]
                                  )
                                    ? _vm._i(
                                        _vm.form.categoriesForGroup[group.id],
                                        categorySlug
                                      ) > -1
                                    : _vm.form.categoriesForGroup[group.id],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.form.categoriesForGroup[group.id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = categorySlug,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.categoriesForGroup,
                                            group.id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.categoriesForGroup,
                                            group.id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.form.categoriesForGroup,
                                        group.id,
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "inline-block mr-2 check",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.categoriesBySlug[categorySlug].title
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has(
                              `event ${group.title}`.toLowerCase()
                            ),
                            expression:
                              "errors.has(`event ${group.title}`.toLowerCase())",
                          },
                        ],
                        staticClass: "text-lg error text-error-red",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.errors.first(
                                `event ${group.title}`.toLowerCase()
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.categoryGroups, function (group) {
        return _vm.user.isAdmin &&
          _vm.categorySlugsByGroupId[group.id] &&
          group.ui_status === "details_admin"
          ? _c("div", { key: group.id, staticClass: "mb-8" }, [
              _c("label", { ref: "categories", refInFor: true }, [
                _vm._v(
                  "\n      Event " + _vm._s(group.title) + " (admin only)\n    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group__checkbox" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap select-box" },
                  [
                    _vm._l(
                      _vm.categorySlugsByGroupId[group.id],
                      function (categorySlug) {
                        return [
                          _c(
                            "label",
                            {
                              key: categorySlug,
                              staticClass:
                                "w-full text-base font-normal md:w-1/2 md:pr-3",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.form.categoriesForGroup[group.id],
                                    expression:
                                      "form.categoriesForGroup[group.id]",
                                  },
                                ],
                                attrs: {
                                  name: `event ${group.title}`.toLowerCase(),
                                  type: "checkbox",
                                },
                                domProps: {
                                  value: categorySlug,
                                  checked: Array.isArray(
                                    _vm.form.categoriesForGroup[group.id]
                                  )
                                    ? _vm._i(
                                        _vm.form.categoriesForGroup[group.id],
                                        categorySlug
                                      ) > -1
                                    : _vm.form.categoriesForGroup[group.id],
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.form.categoriesForGroup[group.id],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = categorySlug,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form.categoriesForGroup,
                                            group.id,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form.categoriesForGroup,
                                            group.id,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.form.categoriesForGroup,
                                        group.id,
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "inline-block mr-2 check",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.categoriesBySlug[categorySlug].title
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("label", { ref: "image", attrs: { for: "image" } }, [
            _vm._v("\n      Main Event Image "),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("span", { staticClass: "mb-5 text-sm font-sans-book block" }, [
              _vm._v(
                "\n        Please upload a horizontal/landscape image (JPEG or PNG), ideally 1424 pixels x 862 pixels.\n        Image must NOT have any text.\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.event && _vm.event.image
            ? _c("div", [
                _c("img", {
                  staticClass: "h-48 mb-2",
                  attrs: { alt: "display image here", src: _vm.event.image },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.imageValidate,
                expression: "imageValidate",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.newImage,
                expression: "form.newImage",
              },
            ],
            attrs: { id: "image", type: "hidden", name: "image" },
            domProps: { value: _vm.form.newImage },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "newImage", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "vue-dropzone",
            {
              ref: "dropzone",
              attrs: {
                id: "dropzone",
                options: _vm.dropzoneOptions,
                useCustomSlot: true,
              },
              on: {
                "vdropzone-success": _vm.uploaded,
                "vdropzone-error": _vm.updateImageErrorMessage,
                "vdropzone-removed-file": _vm.resetImage,
              },
            },
            [
              _c("div", { staticClass: "after-drop-message" }, [
                _c("p", [
                  _vm._v(
                    "You may drag-and-drop an image here. File size must be less than 4 MB."
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.errors.has("image")
            ? _c("span", { staticClass: "text-lg error text-error-red" }, [
                _vm._v(_vm._s(_vm.errors.first("image"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.imageError
            ? _c("span", { staticClass: "text-lg error text-error-red" }, [
                _vm._v(_vm._s(_vm.imageError)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-6" }, [
        _c("label", { ref: "teaser", attrs: { for: "teaser" } }, [
          _vm._v("\n      Teaser "),
          _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
          _vm._v(" "),
          _c("span", { staticClass: "block text-sm font-sans-book" }, [
            _vm._v(
              "\n        200 characters maximum (including spaces). This brief teaser copy is your\n        listing on our event calendar schedule page (alongside other events). It should be enticing and make it clear to\n        attendees what your particular event is about.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.teaser,
              expression: "form.teaser",
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: _vm.teaserValidate,
              expression: "teaserValidate",
            },
          ],
          staticClass:
            "w-full h-48 p-4 mt-3 overflow-y-scroll bg-transparent border border-black",
          attrs: { name: "teaser", id: "teaser" },
          domProps: { value: _vm.form.teaser },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "teaser", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-sm font-sans-italic text-gray-dark" }, [
          _vm._v(
            "\n      Character count: " + _vm._s(_vm.characterCount) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("teaser"),
                expression: "errors.has('teaser')",
              },
            ],
            staticClass: "text-lg error text-error-red",
          },
          [_vm._v("\n      " + _vm._s(_vm.errors.first("teaser")) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c("label", { ref: "description", attrs: { for: "description" } }, [
            _vm._v("\n      Description "),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("span", { staticClass: "block text-sm font-sans-book" }, [
              _vm._v(
                "\n        1000 characters maximum (including spaces). This full description is for your unique event details page.\n        Here, you can expand on your event information and add a bit of context\n        related to the host(s), or any other details to excite potential attendees (e.g., speaker/performer names and\n        bios, etc.) You also can add hyperlinks, where appropriate. NOTE: Teaser copy will appear at the top of your\n        event details page, so do not repeat this exact content in your full description.\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("vue-editor", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              editorToolbar: _vm.descriptionToolbar,
              name: "description",
              id: "description",
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("description"),
                  expression: "errors.has('description')",
                },
              ],
              staticClass: "text-lg error text-error-red",
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.errors.first("description")) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-6 relative" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mb-6" }, [
          _c(
            "ul",
            { staticClass: "list-none p-0" },
            _vm._l(_vm.form.cohosts, function (cohost, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass:
                    "flex pb-2 mb-4 border-b-2 border-slate-500 justify-between items-center",
                },
                [
                  _vm._v("\n          " + _vm._s(cohost.name) + " "),
                  _c(
                    "button",
                    {
                      staticClass: "button-icon py-2 px-3",
                      on: {
                        click: function ($event) {
                          return _vm.removeCohost(index)
                        },
                      },
                    },
                    [_vm._v("x")]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.form.cohosts.length < 3
          ? _c(
              "div",
              { staticClass: "flex mb-2" },
              [
                _c("cohosts-search", {
                  attrs: { clear: _vm.clearSearch },
                  model: {
                    value: _vm.cohostInput,
                    callback: function ($$v) {
                      _vm.cohostInput = $$v
                    },
                    expression: "cohostInput",
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button-icon h-12",
                    on: { click: _vm.addCohost },
                  },
                  [_vm._v("ADD")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6 flex flex-wrap justify-start lg:justify-end" },
        [
          _c(
            "button",
            {
              staticClass: "button",
              class: { "opacity-50 cursor-not-allowed": _vm.saving },
              attrs: { disabled: _vm.saving },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mr-0 lg:mr-4 mb-4 lg:mb-4 w-full lg:w-auto",
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              class: { "opacity-50 cursor-not-allowed": _vm.saving },
              attrs: { disabled: _vm.saving },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.saveNext.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n      Save & Next\n    ")]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "cohosts" } }, [
      _vm._v("\n      Co-hosts\n      "),
      _c("span", { staticClass: "block text-sm font-sans-book mb-4" }, [
        _vm._v(
          "Search and select names of organizations or individuals to credit as event co-hosts. If not listed, please have them create an account at portal.letsreimagine.org. You can add up to three co-hosts by clicking the '+' sign. For any problems, email us at hello@reimagine.org."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }